import styled from 'styled-components';

export const CampNotebooks = styled.div`
  background: white;
  min-height: 100%;
`
